import { $query } from "./index.js";
import { debounce } from "lodash";
import store from "@/store/index";

const inputFocusFn = function (event) {
  if (event.target.matches?.('.opc-input-selectable input.zbo-input__inner')) {
    setTimeout(() => {
      event.target.select?.();
    }, 100);
  }
};

const injectCssThemeVar = function() {
  if(!$query.cssTheme) return;
  const style = document.createElement('style');
  style.type = 'text/css';
  const cssContent = `
    :root{
      --theme-color: ${decodeURIComponent($query.cssTheme)};
    }
  `;
  style.innerHTML = cssContent;
  document.head.appendChild(style);
}

const handleScreenResize = debounce(function() {
  if (typeof window === 'undefined') return;
  const width = window.innerWidth;
  store.commit('setWindowWidth', width);
}, 20);

/*
const avoidOverlapping = debounce(function(){
  if(!document.body.getBoundingClientRect) return;
  const bot = document.querySelector("#livesdk__campaign .livesdk__invitation");
  const botRect = bot.getBoundingClientRect();
  const button = document.querySelector(".opc-layout__action__inner")
  const buttonRect = button.getBoundingClientRect();
  const notOverLapping = (botRect.y + botRect.height < buttonRect.y) || (botRect.y > buttonRect.y + buttonRect.height)
  if(!notOverLapping){
    bot.classList.add("chat-bot__move-up")
  }else{
    bot.classList.remove("chat-bot__move-up")
    document.dispatchEvent(new Event('scroll'))
  };
}, 300, {leading: false, trailing: true})
*/

export default {
  install() {
    if (this.is_mobile_reactive) {
      document.addEventListener('focus', inputFocusFn, true);
      // document.addEventListener('scroll', avoidOverlapping);
    }

    injectCssThemeVar();

    if (typeof window !== 'undefined') {
      store.commit('setWindowWidth', window.innerWidth);
    }

    window.addEventListener('resize', handleScreenResize);
  },
  uninstall() {
    document.removeEventListener('focus', inputFocusFn, true);
    // document.removeEventListener('scroll', avoidOverlapping);
    window.removeEventListener('resize', handleScreenResize);
  },
};
